import React from "react";
import ExcelIcon from "../Common/svg/excelicon";

const SingleDocument = ({ exportItem }) => {
  const formattedDate = exportItem.created_at
  .replace("T", " ")
  .replace("Z", "")
  .split(".")[0];
  return (
    <div className="col-12">
      <div className="card rounded-3">
        <div className="card-body p-3">
          <div className="d-flex justify-content-between">
            <div className="d-flex gap-2">
              <ExcelIcon />
              <div>
                <h6 className="font14 mb-1">{exportItem.file_name}</h6>
                <span>{formattedDate}</span>{" "}
                <span>
                  {exportItem.export_type === "Product" ? "منتجات" : "متاجر"}
                </span>
              </div>
            </div>

            <div>
              <span
                className={`status status-badge me-2 ${exportItem.status === "completed" ? "bg-success" : "bg-warning"}`}
              >
                {exportItem.status === "completed" ? "مكتمل" : "قيد المعالجة"}
              </span>
              {exportItem.status === "completed" && (
                <a
                  className="btn btn-primary"
                  href={exportItem.download_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  تحميل الوثيقة
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleDocument;
